import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';
import { Apollo, QueryRef } from 'apollo-angular';
import { BehaviorSubject } from 'rxjs';
import { take, tap, pluck, withLatestFrom } from 'rxjs/operators';

// * QUERY FILTRO CLIENTES
const QUERY_clientes_registros = gql`
  query (
    $rutEmpresa: Decimal
    $rutCliente: Decimal
    $nombreCliente: String
    $direccionCompleta: String
    $codigoComuna: Int
    $busquedaxEstado: Int
    $esBloqueado: Boolean
    $vendedorSel: [Decimal]
    $paginaActual: Int
    $cantidadRegistrosPorPagina: Int
  ) {
    cliente_proveedor {
      obtenerSegunFiltroMaestraCliente(
        filtro: {
          exacto: {
            rut: $rutCliente
            razon_social: $nombreCliente
            direccion_completa: $direccionCompleta
            codigo_comuna: $codigoComuna
            busquedaxEstado: $busquedaxEstado
            bloqueado: $esBloqueado
            empresa_rut: $rutEmpresa
            es_cliente: true
            vendedorSel: $vendedorSel
          }
        }
        paginaActual: $paginaActual
        cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
      ) {
        respuesta {
          paginaActual
          cantidadRegistrosPorPagina
          totalPaginas
          totalRegistros
          registros {
            rut
            nombre
            razon_social
            mail_intercambio
            mail_pdf
            mail_contacto
            afecto_reglas_comerciales
            es_cliente
            es_proveedor
            telefono_principal
            telefono_secundario
            activo
            fax
            observaciones
            descuento_maximo
            tipo_cliente_codigo
            tipo_cobro_codigo
            lista_precio_codigo
            rut_usuario_creacion
            rut_usuario_actualiza
            fecha_actualizacion
            fecha_registro
            empresa_rut
            bloqueado
            direccion_completa
            localidad
            nombrecomuna
            nombreprovincia
            codigo_direccion
            tipo_cliente_nombre
            tipo_cobro_nombre
            condicion_pago_codigo
            codigo_vendedor
            giro
            codigo_comuna
            es_direccion_despacho
            estado_direccion
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ClientesService {
  private clientesDataSubject = new BehaviorSubject(null);
  Clientess$ = this.clientesDataSubject.asObservable();
  postsQuery: QueryRef<any>;
  queryCliente: any;

  constructor(private gqlclient: GraphQLClient, private apollo: Apollo) {}

  //* DEVUELVE OBSERVABLE CON LA RESPUESTA DE LA QUERY
  GetClientesFiltro(inputParams): void {
    this.postsQuery = this.apollo.watchQuery<any>({
      query: QUERY_clientes_registros,
      variables: inputParams,
      fetchPolicy: 'network-only',
    });
    this.queryCliente = this.postsQuery.valueChanges.pipe(
      take(1),
      pluck('data', 'cliente_proveedor'),
      withLatestFrom(this.Clientess$),
      tap(([apiResponse, respuesta]) => {
        return apiResponse.obtenerSegunFiltroMaestraCliente.respuesta;
      })
    );
  }

  RefreshFiltrosClientes(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query (
            $rutEmpresa: Decimal
            $rutCliente: Decimal
            $nombreCliente: String
            $direccionCompleta: String
            $codigoComuna: Int
            $busquedaxEstado: Int
            $esBloqueado: Boolean
            $vendedorSel: [Decimal]
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            cliente_proveedor {
              obtenerSegunFiltroMaestraCliente(
                filtro: {
                  exacto: {
                    rut: $rutCliente
                    razon_social: $nombreCliente
                    direccion_completa: $direccionCompleta
                    codigo_comuna: $codigoComuna
                    busquedaxEstado: $busquedaxEstado
                    bloqueado: $esBloqueado
                    empresa_rut: $rutEmpresa
                    es_cliente: true
                    vendedorSel: $vendedorSel
                  }
                }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut
                    nombre
                    razon_social
                    mail_intercambio
                    mail_pdf
                    mail_contacto
                    afecto_reglas_comerciales
                    es_cliente
                    es_proveedor
                    telefono_principal
                    telefono_secundario
                    activo
                    fax
                    observaciones
                    descuento_maximo
                    tipo_cliente_codigo
                    tipo_cobro_codigo
                    lista_precio_codigo
                    rut_usuario_creacion
                    rut_usuario_actualiza
                    fecha_actualizacion
                    fecha_registro
                    empresa_rut
                    bloqueado
                    direccion_completa
                    localidad
                    nombrecomuna
                    nombreprovincia
                    codigo_direccion
                    tipo_cliente_nombre
                    tipo_cobro_nombre
                    condicion_pago_codigo
                    codigo_vendedor
                    giro
                    codigo_comuna
                    es_direccion_despacho
                    estado_direccion
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerSegunFiltroMaestraCliente;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerSegunFiltroRubroeIPT(
    inputParams: {
      rutEmpresa: number;
      sucursalCodigo: number;
      rutCliente: number;
      direccionCodigo: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $rutCliente: Decimal, $direccionCodigo: Decimal) {
            vendedor_rubro_cliente {
              obtenerSegunFiltroRubroeIPT(
                filtro: {
                  exacto: { rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalCodigo, cliente_proveedor_rut: $rutCliente, direccion_codigo: $direccionCodigo, vendedor_codigo: -1, rubro_codigo: -1 }
                }
              ) {
                respuesta {
                  registros {
                    cliente_proveedor_rut
                    direccion_codigo
                    lunes
                    martes
                    miercoles
                    jueves
                    viernes
                    sabado
                    domingo
                    es_cobrador
                    nombreRubro
                    nombreVendedor
                    realiza_cobro_maquina
                    rubro_codigo
                    vendedor_codigo
                    listaUnidadNegocio
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.vendedor_rubro_cliente.obtenerSegunFiltroRubroeIPT;
        callback({ mensajes, respuesta });
      }
    );
  }

  rolOperacionPermitida(
    inputParams: {
      rut_usu: number;
      codgo_modulo: number;
      cod_operacion: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rut_usu: Decimal, $codgo_modulo: Decimal, $cod_operacion: Decimal) {
            rol_operacion {
              operacionPermitida(rut_usu: $rut_usu, codgo_modulo: $codgo_modulo, cod_operacion: $cod_operacion) {
                mensajes {
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.rol_operacion.operacionPermitida;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerClienteProveedorSegunId(
    inputParams: {
      rutEmpresa: number;
      rutCliente: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $rutCliente: Decimal) {
            cliente_proveedor {
              obtenerSegunId(entidad: { rut: $rutCliente, empresa_rut: $rutEmpresa }) {
                respuesta {
                  rut
                  nombre
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerSegunId;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerAllRegion(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query {
            region {
              obtenerTodos {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    codigo
                    nombre
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.region.obtenerTodos;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerRubrosCliente(
    inputParams: {
      rutEmpresa: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal) {
            rubro {
              obtenerRubros(empresa_rut: $rutEmpresa) {
                respuesta {
                  registros {
                    codigo
                    descripcion
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.rubro.obtenerRubros;
        callback({ mensajes, respuesta });
      }
    );
  }

  ObtenerTerritorioSegunFiltro(
    inputParams: {
      rutEmpresa: number;
      sucursalEmpresa: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalEmpresa: Decimal) {
            territorio {
              obtenerSegunFiltro(filtro: { exacto: { empresa_rut: $rutEmpresa, sucursal_codigo: $sucursalEmpresa } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    codigo
                    nombre
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.territorio.obtenerSegunFiltro;
        callback({ mensajes, respuesta });
      }
    );
  }

  DatosRutaSegunFiltro(
    inputParams: {
      rutEmpresa: number;
      sucursalEmpresa: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalEmpresa: Decimal) {
            ruta {
              obtenerSegunFiltro(filtro: { exacto: { empresa_rut: $rutEmpresa, sucursal_codigo: $sucursalEmpresa, tipobusqueda: 1 } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    codigo
                    descripcion
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.ruta.obtenerSegunFiltro;
        callback({ mensajes, respuesta });
      }
    );
  }
}
